// extracted by mini-css-extract-plugin
export default {"container":"styles_container__whsY2","label":"styles_label__PHk23","link":"styles_link__BhAB5"};